'use client';

import { WithQueryClient } from '@/lib/query-client';

import { ActiveSubscriptionGuard } from '../../../_components/active-subscription-guard';

export const MarketReportsCartViewWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <WithQueryClient>
            <ActiveSubscriptionGuard cartPageType="market-report">{children}</ActiveSubscriptionGuard>
        </WithQueryClient>
    );
};
